import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Image } from '@fluentui/react-components';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Collapse,
  useCollapseState,
  getPanelErrorProps
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { withCustomValidation, withError } from '@bingads-webui-react/validation';
import { ValidatedFinalUrl as InternalValidatedFinalUrl } from '@bingads-webui-campaign-react/validated-url-input-fluent-v2';
import { ValidatedFormCard, FormCardBasicHeader } from '@bingads-webui-campaign-react/validated-form-cards';
import { FormCardBody } from '@bingads-webui-fluent-component/form-cards';

import FinalUrlImg from '../media/final-url-icon.svg';

const ValidatedFinalUrl = withError(withCustomValidation(InternalValidatedFinalUrl));

export const CollapsibleFinalUrl = ({
  finalUrlsObj,
  additionalProperties,
}) => {
  const i18n = useContext(I18nContext);

  const [
    finalUrlSection,
    finalUrlExpandedSection,
    setFinalUrlExpandedSection,
  ] = useCollapseState(['final-url'], ['final-url']);

  return (
    <Collapse
      allPanelItems={finalUrlSection}
      checkItems
      skipItemsTypeCheck
      activeKeys={finalUrlExpandedSection}
      setActiveKeys={setFinalUrlExpandedSection}
    >
      <ValidatedFormCard
        key="final-url"
        className="final-url-card"
        attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      >
        <FormCardBasicHeader
          title={i18n.getString(_TL_('Final URL'))}
          helpTopic="pop_BA_LinkedIn_FinalURL"
          helpLabel={i18n.getString(_TL_('Click to learn more about final URL'))}
          contentBefore={<Image src={FinalUrlImg} aria-hidden />}
        />
        <FormCardBody>
          <ValidatedFinalUrl
            containerClassName="final-url-container"
            hideLabel
            i18n={i18n}
            validationProps={{
              data: finalUrlsObj,
              initialValue: finalUrlsObj,
            }}
            validateOnRender
            additionalProperties={additionalProperties}
          />
        </FormCardBody>
      </ValidatedFormCard>
    </Collapse>
  );
};

CollapsibleFinalUrl.propTypes = {
  finalUrlsObj: PropTypes.shape({}).isRequired,
  additionalProperties: PropTypes.shape({}).isRequired,
};
